import {Component, OnInit} from "@angular/core";
import {ReportService} from "~/app/core/reports/services/report.service";
import {Chain} from "@model/Chain";
import {HotStore} from "@model/HotStore";
import {UserService} from "~/app/core/services/user.service";
import {UserAccessService} from "~/app/core/services/user-access.services";
import {LocalStorageIndexedService} from "~/app/web/AppProvider/LocalStorageIndexedService";
import {HomeOffice} from "@model/HomeOffice";
import {StoreReportGroupingService} from "~/app/core/services/store-report-grouping.service";
import {Group} from "~/app/core/reports/models/group";
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import { LoadingIndicatorHelper } from "~/app/core/services/loading-indicator-helper";

@Component({
  selector: 'app-store-report-grouping',
  templateUrl: './store-report-grouping.component.html',
  styleUrls: ['./store-report-grouping.component.scss']
})

export class StoreReportGroupingComponent implements OnInit {
  private _name: string;
  private _username: string;
  firstLabelName = "Group ID: ";
  groupIdOn: boolean = false;
  parentGridChange = false;
  createButtonClicked: boolean = false;
  groupIdList: Group[] = [];
  storeGroupListA: HotStore[] = [];
  storeGroupListU: HotStore[] = [];
  finalUpdateList: Chain[] = [];
  newAssignedUpdateList: HotStore[] = [];
  newDeleteUpdateList: HotStore[] = [];
  groupList: string[] = [];
  hotId: string;
  selectedHomeOffice: HomeOffice;
  selectedHoId: string;
  groupIdValue: string;
  groupDescValue: string;
  comboData: string[] = [];
  assignedStores: HotStore[] = [];
  unassignedStores: HotStore[] = [];
  selectedGroupId: string;

  constructor(public reportService: ReportService,
              public userService: UserService,
              public userAccessService: UserAccessService,
              private _localStorage: LocalStorageIndexedService,
              public loadingIndicator: LoadingIndicatorHelper,
              public storeReportGroupService: StoreReportGroupingService,
              public dialogService: FSInvoiceDialogService
             ) {

  }

  async ngOnInit() {
    this.createButtonClicked = false;
    this.parentGridChange = false;
    this.groupDescValue = null;
    this.groupIdValue = '';
    this.selectedGroupId = null;
    this.assignedStores = [];
    this.unassignedStores = [];
    this.newDeleteUpdateList = [];
    this.newAssignedUpdateList = [];

    this._username = this.userService.getUserName().toUpperCase()
    this.selectedHoId = this.userAccessService.getSelectedHoId();

    this.groupIdList = await this.storeReportGroupService.getGroupHeaders(this.selectedHoId);
  }

  filterStores(groupId: string): string[] {
    let tempList = [];
    let count = 0;

    if(groupId) {
      this.storeGroupListA.forEach((item) => {
        this._name = item['chainID'] + ' - ' + item['storeID'];
       item.name = this._name;
      });
    }
    return tempList;
  }

  async groupIdValueChange(e) {
    this.loadingIndicator.show();
    if (e !== undefined) {
      this.groupDescValue = e.groupDesc;
      this.storeReportGroupService.setGroupDesc(e.groupDesc);

      this.storeGroupListA = await this.storeReportGroupService.getAssignedStores(this.selectedHoId, e.groupId);
      let newArrayA = JSON.parse(JSON.stringify(this.storeGroupListA));
      this.storeReportGroupService.setAStores(newArrayA);

      this.storeGroupListU = await this.storeReportGroupService.getUnassignedStores(this.selectedHoId, e.groupId);
      let newArrayU = JSON.parse(JSON.stringify(this.storeGroupListU));
      this.storeReportGroupService.setUStores(newArrayU);

      this.storeGroupListA.forEach((item) => {
        this._name = item['chainID'] + ' - ' + item['storeID'];
        item.name = this._name;
      });

      this.storeGroupListU.forEach((item) => {
        this._name = item['chainID'] + ' - ' + item['storeID'];
        item.name = this._name;
      });

      this.parentGridChange = true;
      this.assignedStores = [];
      this.unassignedStores = [];
      this.groupIdValue = e.groupId;
      this.groupDescValue = e.groupDesc;

    } else {
      await this.ngOnInit();
    }

    this.loadingIndicator.hide();
  }

  async pickListFormResults(e): Promise<void> {
    this.loadingIndicator.show();

    this.storeReportGroupService.setGroupIdValue(this.selectedGroupId);
    this.assignedStores = this.storeReportGroupService.getAStores();

    this.unassignedStores = this.storeReportGroupService.getUStores();

    if(e) {
      e.forEach((item, idx) => {
          let index = this.assignedStores.findIndex(store => store.storeID === item.storeID);
          if (index <= -1) {
            item.groupId = this.groupIdValue;
            this.newAssignedUpdateList.push(item);
          }
      });

      this.assignedStores.forEach((item, idx) => {
        let index = e.findIndex(store => store.storeID === item.storeID);
        if (index <= -1) {
          let tempItem = item;
          tempItem.groupId = this.groupIdValue;
          this.newDeleteUpdateList.push(tempItem);
        }
      });

      if(this.newAssignedUpdateList.length > 0) {
        await this.storeReportGroupService.updateStoreGrouping(this.newAssignedUpdateList)
          .then(r => r);
      }

      if(this.newDeleteUpdateList.length > 0) {
        await this.storeReportGroupService.removeStoreGrouping(this.newDeleteUpdateList)
          .then(r => r);
      }

      this.storeReportGroupService.setAStores(e);

      await this.ngOnInit();
      this.selectedGroupId = this.storeReportGroupService.getGroupIdValue();
      this.groupDescValue = this.storeReportGroupService.getGroupDesc();

    } else {
      if(this.groupIdValue && this.groupDescValue) {
        await this.storeReportGroupService.createGroup(this.selectedHoId, this.groupIdValue, this.groupDescValue).then((r) => {
          if(r === 0) {
            this.userService.showNotification('Group Created Successfully', 2000);
          }
        }).catch((error) => {
          console.error(error);
          this.userService.showError('Problem Creating Group', 2000);
        });
      } else {
        this.userService.showNotification('Missing Group Description', 2000);
     }
     await this.ngOnInit();
    }
    this.parentGridChange = true;
    this.loadingIndicator.hide();
  }

  createClicked() {
    this.createButtonClicked = true;
    this.parentGridChange = false;
    this.groupDescValue = null;
    this.groupIdValue = null;
    this.selectedGroupId = null;
    this.assignedStores = null;
    this.unassignedStores = null;
    this.storeGroupListA = null;
    this.storeGroupListU = null;
  }

  deleteClicked(e) {
    this.dialogService.openDialog({
      type: DialogType.INFO,
      title: 'Remove Group',
      content: 'Are you sure you want to delete?',
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Ok', primary: true},
      ],
      width: 400
    }).then(async (answer) => {
      if(answer === 'Ok') {
        this.loadingIndicator.show();
        await this.storeReportGroupService.deleteGroup(this.selectedHoId, this.groupIdValue).then((r) => {
          this.userService.showNotification('Delete Successful', 2000);
          this.ngOnInit();

        }).catch((error) => {
          console.error(error);
          this.userService.showError('Unable to delete group', 2000)
          this.ngOnInit();
        });
        this.storeGroupListA = null;
        this.storeGroupListU = null;
        this.loadingIndicator.hide();
      }
    })
  }

  groupDescValueChange(e) {
    if (e !== undefined) {
      this.parentGridChange = true;
    }
  }

  cancelClicked(e) {
    this.createButtonClicked = false;
    this.parentGridChange = false;
    this.groupDescValue = '';
  }
}


